<template>
  <li
    class="mt-3 content-vertical-aligned"
    style="display: table;"
  >
    <font-awesome-icon
      :class="'tc mr-2 text-' + color"
      :icon="['fal', icon]"
      style="display: table-cell;"
    ></font-awesome-icon>
    <span
      style="display: table-cell;"
    ><slot></slot></span>
  </li>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      default() {
        return 'check-circle'
      },
    },
    color: {
      type: String,
      default() {
        return 'primary'
      },
    },
  },

}
</script>
